import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "zhudanmingxi"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  style: {
    "color": "green",
    "text-decoration": "underline dotted"
  }
};
const _hoisted_4 = {
  key: 0,
  style: {
    "width": "100%"
  }
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = {
  key: 2
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "盘", -1);

const _hoisted_10 = {
  style: {
    "color": "#409eff"
  }
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("@ ");

const _hoisted_12 = {
  style: {
    "color": "red"
  }
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  key: 1
};
const _hoisted_15 = {
  key: 0,
  class: "danger-color",
  style: {
    "color": "red"
  }
};
const _hoisted_16 = {
  style: {
    "color": "red"
  }
};
const _hoisted_17 = {
  style: {
    "color": "#409eff"
  }
};
const _hoisted_18 = {
  style: {
    "color": "#333"
  }
};

const _hoisted_19 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_20 = {
  style: {
    "color": "red"
  }
};
const _hoisted_21 = {
  style: {
    "color": "#409eff"
  }
};
const _hoisted_22 = {
  style: {
    "color": "#333"
  }
};

const _hoisted_23 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_24 = {
  style: {
    "color": "red"
  }
};
const _hoisted_25 = {
  style: {
    "color": "#409eff"
  }
};
const _hoisted_26 = {
  style: {
    "color": "#333"
  }
};

const _hoisted_27 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_28 = {
  style: {
    "color": "red"
  }
};
const _hoisted_29 = {
  style: {
    "color": "#409eff"
  }
};
const _hoisted_30 = {
  style: {
    "color": "#333"
  }
};

const _hoisted_31 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_32 = {
  style: {
    "color": "red"
  }
};
const _hoisted_33 = {
  style: {
    "color": "#409eff"
  }
};
const _hoisted_34 = {
  style: {
    "color": "#333"
  }
};

const _hoisted_35 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_36 = {
  style: {
    "color": "red"
  }
};
const _hoisted_37 = {
  style: {
    "color": "#409eff"
  }
};
const _hoisted_38 = {
  style: {
    "color": "#333"
  }
};

const _hoisted_39 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_40 = {
  style: {
    "color": "red"
  }
};
const _hoisted_41 = {
  style: {
    "color": "#409eff"
  }
};
const _hoisted_42 = {
  style: {
    "color": "#333"
  }
};

const _hoisted_43 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_44 = {
  style: {
    "color": "red"
  }
};
const _hoisted_45 = {
  style: {
    "color": "#409eff"
  }
};

const _hoisted_46 = /*#__PURE__*/_createTextVNode("-");

const _hoisted_47 = /*#__PURE__*/_createTextVNode("『未派彩』");

const _hoisted_48 = {
  key: 1
};
const _hoisted_49 = {
  key: 1
};
const _hoisted_50 = {
  class: "paging"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_table_column = _resolveComponent("el-table-column");

  const _component_el_popover = _resolveComponent("el-popover");

  const _component_el_table = _resolveComponent("el-table");

  const _component_el_pagination = _resolveComponent("el-pagination");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_table, {
    data: $data.dialog.detail_data,
    border: "",
    size: "small",
    "highlight-current-row": "",
    "header-cell-class-name": "table-header-cell",
    "header-row-class-name": "table-header-row",
    "row-class-name": $options.tableRowClassName_del_red_line,
    "table-layout": "auto"
  }, {
    default: _withCtx(() => [!$data.isGetBuHuoDetail ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 0,
      prop: "method_name",
      label: "注单号/下注时间",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.order_id), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$filters.time(scope.row.runtime, "报表注单")), 1)]),
      _: 1
    })) : _createCommentVNode("", true), $data.isGetBuHuoDetail ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 1,
      prop: "method_name",
      label: "补货时间",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.let_posttime != undefined ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$filters.time(scope.row.let_posttime, "报表注单")), 1)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(_ctx.$filters.time(scope.row.posttime, "报表注单")), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "game_name",
      label: "彩种/期号",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.game_name), 1), _createVNode(_component_el_popover, {
        placement: "bottom",
        width: "100%",
        onShow: $event => $options.show_kaijiang(scope.row)
      }, {
        reference: _withCtx(() => [_createElementVNode("div", _hoisted_3, _toDisplayString(scope.row.qnum), 1)]),
        default: _withCtx(() => [$data.componentId ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent($data.componentId), {
          history_data: $data.history_data,
          gid: $data.gid
        }, null, 8, ["history_data", "gid"]))], 1024))])) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["onShow"])]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "username",
      label: "账号/盘口",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.username), 1), scope.row.level_id != undefined && scope.row.level_id != null ? (_openBlock(), _createElementBlock("div", _hoisted_5, [scope.row.level_id.includes('1') ? (_openBlock(), _createElementBlock("span", _hoisted_6, "A")) : _createCommentVNode("", true), scope.row.level_id.includes('2') ? (_openBlock(), _createElementBlock("span", _hoisted_7, "B")) : _createCommentVNode("", true), scope.row.level_id.includes('3') ? (_openBlock(), _createElementBlock("span", _hoisted_8, "C")) : _createCommentVNode("", true), _hoisted_9])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_table_column, {
      prop: "bet_info",
      label: "下注明细",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", _hoisted_10, _toDisplayString(scope.row.title) + "『" + _toDisplayString(scope.row.bet_name) + "』", 1), _hoisted_11, _createElementVNode("span", _hoisted_12, _toDisplayString(scope.row.list_bonus), 1)]),
      _: 1
    }), $data.isGetBuHuoDetail ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 2,
      prop: "man_fly_bill",
      label: "手动补货金额",
      align: "center"
    }, {
      default: _withCtx(scope => [$props.form.settle_state == 2 ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(scope.row.user_manlet_let * 1 || 0), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(scope.row.man_fly_bill * 1 || 0), 1))]),
      _: 1
    })) : _createCommentVNode("", true), $data.isGetBuHuoDetail ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 3,
      prop: "fly_bill",
      label: "自动补货金额",
      align: "center"
    }, {
      default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(scope.row.fly_bill * 1 || 0), 1)]),
      _: 1
    })) : _createCommentVNode("", true), $data.isGetBuHuoDetail ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 4,
      prop: "let_rate",
      label: "补货赔率",
      align: "center"
    })) : _createCommentVNode("", true), !$data.isGetBuHuoDetail ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 5,
      prop: "balance",
      label: "下注本金",
      align: "center"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.balance) + " ", 1), scope.row.order_staus == -1 ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(scope.row.remark ? scope.row.remark : "已撤单"), 1)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), !$data.isGetBuHuoDetail ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 6,
      prop: "bonus",
      label: "输赢结果",
      align: "center"
    }, {
      default: _withCtx(scope => [$props.form.settle_state != 2 ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(scope.row.bonus - scope.row.balance >= 0 ? '' : 'redcolor')
      }, _toDisplayString((scope.row.bonus - scope.row.balance).toFixed(1)), 3)) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "rebate_balance",
      label: "会员退水",
      align: "center"
    }), _ctx.$store.state.userinfo.group_id == 3 && $data.is_eran == 1 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 7,
      prop: "trader_balance",
      label: "赚取赔差",
      align: "center"
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 2 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 8,
      prop: "rebate_balance",
      label: "大总监",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.agent_list_2.some(item => item.name == '大总监') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_16, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "大总监").occupy_bill), 1), _createElementVNode("div", _hoisted_17, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "大总监").occupy), 1), _createElementVNode("div", _hoisted_18, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "大总监").username), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_19], 64))]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 3 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 9,
      prop: "rebate_balance",
      label: "总监",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.agent_list_2.some(item => item.name == '总监') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_20, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "总监").occupy_bill), 1), _createElementVNode("div", _hoisted_21, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "总监").occupy), 1), _createElementVNode("div", _hoisted_22, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "总监").username), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_23], 64))]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 4 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 10,
      prop: "rebate_balance",
      label: "分公司",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.agent_list_2.some(item => item.name == '分公司') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_24, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "分公司").occupy_bill), 1), _createElementVNode("div", _hoisted_25, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "分公司").occupy), 1), _createElementVNode("div", _hoisted_26, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "分公司").username), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_27], 64))]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 5 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 11,
      prop: "rebate_balance",
      label: "大股东",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.agent_list_2.some(item => item.name == '大股东') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_28, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "大股东").occupy_bill), 1), _createElementVNode("div", _hoisted_29, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "大股东").occupy), 1), _createElementVNode("div", _hoisted_30, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "大股东").username), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_31], 64))]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 6 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 12,
      prop: "rebate_balance",
      label: "股东",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.agent_list_2.some(item => item.name == '股东') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_32, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "股东").occupy_bill), 1), _createElementVNode("div", _hoisted_33, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "股东").occupy), 1), _createElementVNode("div", _hoisted_34, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "股东").username), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_35], 64))]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 7 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 13,
      prop: "rebate_balance",
      label: "总代理",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.agent_list_2.some(item => item.name == '总代理') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_36, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "总代理").occupy_bill), 1), _createElementVNode("div", _hoisted_37, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "总代理").occupy), 1), _createElementVNode("div", _hoisted_38, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "总代理").username), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_39], 64))]),
      _: 1
    })) : _createCommentVNode("", true), _ctx.$store.state.userinfo.group_id < 8 ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 14,
      prop: "rebate_balance",
      label: "代理",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.agent_list_2.some(item => item.name == '代理') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_40, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "代理").occupy_bill), 1), _createElementVNode("div", _hoisted_41, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "代理").occupy), 1), _createElementVNode("div", _hoisted_42, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "代理").username), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_43], 64))]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "rebate_balance",
      label: "您的占成",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.agent_list_2.some(item => item.name == '自己') ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("div", _hoisted_44, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "自己").occupy_bill), 1), _createElementVNode("div", _hoisted_45, _toDisplayString(scope.row.agent_list_2.find(item => item.name == "自己").occupy), 1)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [_hoisted_46], 64))]),
      _: 1
    }), !$data.isGetBuHuoDetail ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 15,
      prop: "myResult",
      label: "您的结果",
      align: "center"
    }, {
      default: _withCtx(scope => [$props.form.settle_state == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_47], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
        key: 1
      }, [scope.row.myResult ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(scope.row.myResult >= 0 ? '' : 'redcolor')
      }, _toDisplayString(scope.row.myResult * 1), 3)) : (_openBlock(), _createElementBlock("span", _hoisted_48, "0"))], 64))]),
      _: 1
    })) : (_openBlock(), _createBlock(_component_el_table_column, {
      key: 16,
      prop: "let_res",
      label: "补货结果",
      align: "center"
    }, {
      default: _withCtx(scope => [scope.row.let_res ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(scope.row.let_res > 0 ? '' : 'redcolor')
      }, _toDisplayString(scope.row.let_res * 1), 3)) : (_openBlock(), _createElementBlock("span", _hoisted_49, "0"))]),
      _: 1
    })), $data.isGetBuHuoDetail ? (_openBlock(), _createBlock(_component_el_table_column, {
      key: 17,
      prop: "user_remark",
      label: "补货方式",
      align: "center"
    })) : _createCommentVNode("", true), _createVNode(_component_el_table_column, {
      prop: "platform",
      label: "下注平台",
      align: "center"
    }, {
      default: _withCtx(scope => [_createTextVNode(_toDisplayString(scope.row.platform), 1)]),
      _: 1
    })]),
    _: 1
  }, 8, ["data", "row-class-name"]), _createElementVNode("div", _hoisted_50, [_createVNode(_component_el_pagination, {
    small: "",
    onCurrentChange: $options.dialog_change_page,
    modelValue: $data.dialog.page,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.dialog.page = $event),
    "page-size": 20,
    "pager-count": 5,
    total: $data.dialog.pagination.total_records * 1,
    layout: "total,prev,pager,next,jumper"
  }, null, 8, ["onCurrentChange", "modelValue", "total"])])]);
}